var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92969 11.7464L10.2919 14.1633L15.7544 8.57422",
    stroke: "#26445A",
    strokeWidth: 1.26,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.47316,
    y: 2.99856,
    width: 16.7412,
    height: 16.7412,
    rx: 1.88824,
    stroke: "#26445A",
    strokeWidth: 1.25883
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoices);
export default __webpack_public_path__ + "static/media/Choices.aca470081c546aa2f3db68ca0dc0ae5e.svg";
export { ForwardRef as ReactComponent };